import "./Past_result_New.css";
import { useState, useEffect } from "react";
import { Drop_down_selection } from "./Drop_down_selection";

import Right_nav from "./Right_nav";
import Algo_defination from "./Algo_defeination";

/* =========================================================
   SKELETON
   ========================================================= */

function SkeletonLoading() {
  return (
    <div className="alg1_card past_result_main_new">
      <div className="page-layout">
        <header className="skeleton-header">
          <div className="skeleton skeleton-logo"></div>
          <div className="skeleton skeleton-nav"></div>
          <div className="skeleton skeleton-actions"></div>
        </header>

        <div className="main-grid">
          <main className="skeleton-body">
            <div className="skeleton skeleton-title"></div>

            <div className="skeleton skeleton-line"></div>
            <div className="skeleton skeleton-line"></div>
            <div className="skeleton skeleton-line short"></div>

            <div className="skeleton-cards">
              <div className="skeleton skeleton-card"></div>
              <div className="skeleton skeleton-card"></div>
              <div className="skeleton skeleton-card"></div>
            </div>
          </main>

          <aside className="skeleton-right-nav">
            <div className="skeleton skeleton-sidebar-title"></div>
            <div className="skeleton skeleton-sidebar-item"></div>
            <div className="skeleton skeleton-sidebar-item"></div>
            <div className="skeleton skeleton-sidebar-item"></div>
            <div className="skeleton skeleton-sidebar-item"></div>
          </aside>
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   VALUE HELPER
   ========================================================= */

function Value({ children }) {
  return <span className="data_value">{children ?? "—"}</span>;
}

/* =========================================================
   COMPARISON TABLE
   ========================================================= */

function ComparisonTable({
  title,
  homeExpected,
  awayExpected,
  homeScore,
  awayScore,
}) {
  return (
    <section className="comparison_section">
      <div className="comparison_title">{title}</div>

      <table className="comparison_table">
        <thead>
          <tr>
            <th>Metric</th>
            <th>Home</th>
            <th>Away</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Expected Goals</td>
            <td>
              <Value>{homeExpected}</Value>
            </td>
            <td>
              <Value>{awayExpected}</Value>
            </td>
          </tr>

          <tr>
            <td>Correct Score</td>
            <td>
              <Value>{homeScore}</Value>
            </td>
            <td>
              <Value>{awayScore}</Value>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}

/* =========================================================
   MAIN COMPONENT
   ========================================================= */

export default function Past_result_New() {
  const [activePage, setActivePage] = useState("");
  const [teams, setTeams] = useState([]);
  console.log("teams_-", teams);

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 7;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [expandedIndex, setExpandedIndex] = useState(null);

  const [teamDetails, setTeamDetails] = useState({});
  console.log("team_detailes_tot", teamDetails);
  const [original, setOriginal] = useState({});

  const [expandedMatch, setExpandedMatch] = useState({});
  const [matchApiData, setMatchApiData] = useState({});

  const [loadingKey, setLoadingKey] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  /* =========================================================
     PAGINATION
     ========================================================= */

  const totalPages = Math.ceil(teams.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentTeams = teams.slice(indexOfFirstItem, indexOfLastItem);

  const goToPage = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) {
      return;
    }

    setCurrentPage(pageNumber);

    // Close active team when changing page
    setExpandedIndex(null);

    // Close open matches
    setExpandedMatch({});
  };

  const nextPage = () => {
    goToPage(Math.min(currentPage + 1, totalPages));
  };

  const prevPage = () => {
    goToPage(Math.max(currentPage - 1, 1));
  };

  /* =========================================================
     FETCH TEAMS
     ========================================================= */

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${API_URL}/pastresults/tableNames`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setTeams(data || []);
      } catch (err) {
        console.error("Error fetching teams:", err);

        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  /* =========================================================
     TEAM EXPANSION
     ========================================================= */

  const toggleExpand = async (teamKey) => {
    // Closing currently active team
    if (expandedIndex === teamKey) {
      setExpandedIndex(null);

      // Close matches too
      setExpandedMatch({});

      return;
    }

    // Open team immediately
    setExpandedIndex(teamKey);

    // Fetch only once
    if (!teamDetails[teamKey]) {
      try {
        const res = await fetch(
          `${API_URL}/teamdetails/${teamKey}`
        );

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();
        console.log("dtayuy", data);

        const details = data?.data || [];

        setTeamDetails((prev) => ({
          ...prev,
          [teamKey]: details,
        }));

        setOriginal((prev) => ({
          ...prev,
          [teamKey]: details,
        }));
      } catch (err) {
        console.error("Error fetching team details:", err);
      }
    }
  };

  /* =========================================================
     MATCH DATA
     ========================================================= */

  const fetchMatchData = async (matchKey) => {
    try {
      setLoadingKey(matchKey);

      const res = await fetch(
        `${API_URL}/match-details/${matchKey}`
      );

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json();

      setMatchApiData((prev) => ({
        ...prev,
        [matchKey]: data,
      }));
    } catch (err) {
      console.error("Error fetching match details:", err);
    } finally {
      setLoadingKey(null);
    }
  };

  const toggleExpandMatch = (matchKey) => {
    const willExpand = !expandedMatch[matchKey];

    setExpandedMatch((prev) => ({
      ...prev,
      [matchKey]: willExpand,
    }));

    if (willExpand && !matchApiData[matchKey]) {
      fetchMatchData(matchKey);
    }
  };

  /* =========================================================
     LOADING / ERROR
     ========================================================= */

  if (loading) {
    return <SkeletonLoading />;
  }

  if (error) {
    return (
      <div className="past_result_error">
        <strong>Unable to load results</strong>
        <span>{error}</span>
      </div>
    );
  }

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <div className="alg1_card past_result_main_new">
      <div className="page-layout">
        {/* =================================================
            HEADER
        ================================================= */}

        <header className="skeleton-header real_header">
          <span>TEAM RESULTS</span>
        </header>

        {/* =================================================
            MAIN GRID
        ================================================= */}

        <div className="main-grid">
          <main className="real-body">
            {/* =================================================
                WEEK
            ================================================= */}

            <div className="week_label">
              <span className="week_label_text">WEEK</span>

              <span className="week_number">{currentPage}</span>
            </div>

            {/* =================================================
                RESULTS
            ================================================= */}

            <div
              className={`results_section ${
                expandedIndex ? "team_is_active" : ""
              }`}
            >
              <div className="team_cards_container">
                {currentTeams.map((team) => {
                  const teamKey = team.tableName;

                  const isExpanded = expandedIndex === teamKey;

                  const isHidden = expandedIndex !== null && !isExpanded;

                  const details = teamDetails[teamKey];

                  return (
                    <div
                      className={`team_card ${
                        isExpanded ? "team_card_active" : ""
                      } ${isHidden ? "team_card_hidden" : ""}`}
                      key={teamKey}
                    >
                      {/* =================================================
                          TEAM HEADER
                      ================================================= */}

                      <button
                        type="button"
                        className="team_header"
                        onClick={() => toggleExpand(teamKey)}
                        aria-expanded={isExpanded}
                      >
                        <div className="team_identity">
                          <span className="team_title">{teamKey}</span>

                          <span className="team_result_count">
                            {team.correct_count}
                            <span>/</span>
                            {team.total_count}
                            <small>results</small>
                          </span>
                        </div>

                        <div className="team_header_right">
                          {isExpanded && (
                            <span className="close_team">CLOSE</span>
                          )}

                          <span className={`arrow ${isExpanded ? "open" : ""}`}>
                            &#9654;
                          </span>
                        </div>
                      </button>

                      {/* =================================================
                          TEAM DETAILS
                      ================================================= */}

                      <div
                        className={`team_details_wrapper ${
                          isExpanded ? "open" : ""
                        }`}
                      >
                        <div className="team_details">
                          {!details ? (
                            <div className="team_loading">
                              <span className="mini_spinner"></span>
                              Loading team results...
                            </div>
                          ) : (
                            <>
                              {/* =================================================
                                  FILTER
                              ================================================= */}

                              <div className="team_filter">
                                <Drop_down_selection
                                  setTeamDetails={setTeamDetails}
                                  teamKey={teamKey}
                                  original={original[teamKey]}
                                />
                              </div>

                              {/* =================================================
                                  MATCHES
                              ================================================= */}

                              <div className="matches_heading">
                                <div>
                                  <span className="matches_heading_title">
                                    MATCH RESULTS
                                  </span>

                                  <span className="matches_heading_count">
                                    {details.length}
                                  </span>
                                </div>

                                <span className="matches_heading_hint">
                                  Select a match for details
                                </span>
                              </div>

                              <ul className="team_details_list">
                                {details.map((match, matchIndex) => {
                                  const matchKey = match.Team_code;

                                  const isMatchExpanded =
                                    !!expandedMatch[matchKey];

                                  const apiData = matchApiData[matchKey];

                                  return (
                                    <li
                                      key={match.Team_code || matchIndex}
                                      className={`match_item ${
                                        isMatchExpanded
                                          ? "match_item_active"
                                          : ""
                                      }`}
                                    >
                                      {/* =================================================
                                          MATCH HEADER
                                      ================================================= */}

                                      <button
                                        type="button"
                                        className="match_header"
                                        onClick={() =>
                                          toggleExpandMatch(matchKey)
                                        }
                                        aria-expanded={isMatchExpanded}
                                      >
                                        <div className="match_summary">
                                          <span
                                            className={`result_dot ${
                                              match.status === "won"
                                                ? "correct_prediction"
                                                : match.status === "lost"
                                                ? "wrong_prediction"
                                                : "unknown_prediction"
                                            }`}
                                            title={
                                              match.status === "won"
                                                ? "Correct prediction"
                                                : match.status === "lost"
                                                ? "Wrong prediction"
                                                : "Unknown result"
                                            }
                                          ></span>
                                          <span
                                            className={`status-badge ${
                                              match.status === "won"
                                                ? "status-won"
                                                : match.status === "lost"
                                                ? "status-lost"
                                                : "status-pending"
                                            }`}
                                          >
                                            {match.status}
                                          </span>

                                          <div className="teams_score">
                                            <span className="home_team">
                                              {match.Home_Team}
                                            </span>

                                            <span className="score">
                                              {match.Home_score}
                                              <span>:</span>
                                              {match.Away_score}
                                            </span>

                                            <span className="away_team">
                                              {match.Away_Team}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="match_meta">
                                          <span className="match_prediction">
                                            {match.Prediction}
                                          </span>

                                          <span className="match_league">
                                            {match.League}
                                          </span>

                                          <span className="match_schedule">
                                            {match.Schedule}
                                          </span>
                                        </div>

                                        <span
                                          className={`match_arrow ${
                                            isMatchExpanded ? "open" : ""
                                          }`}
                                        >
                                          &#9654;
                                        </span>
                                      </button>

                                      {/* =================================================
                                          MATCH DETAILS
                                      ================================================= */}

                                      <div
                                        className={`match_details_wrapper ${
                                          isMatchExpanded ? "open" : ""
                                        }`}
                                      >
                                        <div className="match_details_content">
                                          {loadingKey === matchKey &&
                                          !apiData ? (
                                            <div className="match_loading">
                                              <span className="mini_spinner"></span>
                                              Loading extra data...
                                            </div>
                                          ) : apiData ? (
                                            <>
                                              {/* =================================================
                                                  COMPARISON TABLES
                                              ================================================= */}

                                              <div className="comparison_grid">
                                                <ComparisonTable
                                                  title="GENERAL CALC"
                                                  homeExpected={
                                                    apiData.general_H_exp_g
                                                  }
                                                  awayExpected={
                                                    apiData.general_A_exp_g
                                                  }
                                                  homeScore={
                                                    apiData.general_CS_1
                                                  }
                                                  awayScore={
                                                    apiData.general_CS_2
                                                  }
                                                />

                                                <ComparisonTable
                                                  title="ODDS"
                                                  homeExpected={
                                                    apiData.odds_H_exp_g
                                                  }
                                                  awayExpected={
                                                    apiData.odds_A_exp_g
                                                  }
                                                  homeScore={apiData.odds_CS_1}
                                                  awayScore={apiData.odds_CS_2}
                                                />

                                                <ComparisonTable
                                                  title="DECAY"
                                                  homeExpected={
                                                    apiData.decay_H_exp_g
                                                  }
                                                  awayExpected={
                                                    apiData.decay_A_exp_g
                                                  }
                                                  homeScore={apiData.decay_CS_1}
                                                  awayScore={apiData.decay_CS_2}
                                                />

                                                <ComparisonTable
                                                  title="FORM"
                                                  homeExpected={
                                                    apiData.form_H_exp_g
                                                  }
                                                  awayExpected={
                                                    apiData.form_A_exp_g
                                                  }
                                                  homeScore={apiData.form_CS_1}
                                                  awayScore={apiData.form_CS_2}
                                                />
                                              </div>

                                              {/* =================================================
                                                  OTHER METRICS
                                              ================================================= */}

                                              <div className="metrics_table_wrapper">
                                                <table className="metrics_table">
                                                  <tbody>
                                                    <tr>
                                                      <th>Goals Mean</th>
                                                      <td>
                                                        <Value>
                                                          {apiData.H_mean}
                                                        </Value>
                                                        <span className="versus">
                                                          -
                                                        </span>
                                                        <Value>
                                                          {apiData.A_mean}
                                                        </Value>
                                                      </td>

                                                      <th>CV Mean</th>
                                                      <td>
                                                        <Value>
                                                          {apiData.H_cv}
                                                        </Value>
                                                        <span className="versus">
                                                          -
                                                        </span>
                                                        <Value>
                                                          {apiData.A_cv}
                                                        </Value>
                                                      </td>
                                                    </tr>

                                                    <tr>
                                                      <th>H-2-H</th>
                                                      <td>
                                                        <Value>
                                                          {apiData.Home_score}
                                                        </Value>
                                                        <span className="versus">
                                                          -
                                                        </span>
                                                        <Value>
                                                          {apiData.Away_score}
                                                        </Value>
                                                      </td>

                                                      <th>Prediction 3</th>
                                                      <td>
                                                        <Value>
                                                          {apiData.Prediction_3 ??
                                                            "null"}
                                                        </Value>
                                                      </td>
                                                    </tr>

                                                    <tr>
                                                      <th>Category</th>
                                                      <td>
                                                        <Value>
                                                          {apiData.category ??
                                                            "null"}
                                                        </Value>
                                                      </td>

                                                      <th>Total Prediction</th>
                                                      <td>
                                                        <Value>
                                                          {Number(
                                                            apiData.H_mean || 0
                                                          ) +
                                                            Number(
                                                              apiData.A_mean ||
                                                                0
                                                            )}
                                                        </Value>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="match_loading">
                                              No additional data available.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* =================================================
                PAGINATION
            ================================================= */}

            {totalPages > 1 && (
              <nav
                className="pagination_nav"
                aria-label="Team results pagination"
              >
                <button
                  type="button"
                  className="pagination_arrow"
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  aria-label="Previous page"
                >
                  &#10094;
                </button>

                <div className="pagination_numbers">
                  {Array.from({ length: totalPages }, (_, index) => {
                    const pageNumber = index + 1;

                    return (
                      <button
                        type="button"
                        key={pageNumber}
                        className={`pagination_number ${
                          currentPage === pageNumber ? "active" : ""
                        }`}
                        onClick={() => goToPage(pageNumber)}
                        aria-current={
                          currentPage === pageNumber ? "page" : undefined
                        }
                      >
                        {pageNumber}
                      </button>
                    );
                  })}
                </div>

                <button
                  type="button"
                  className="pagination_arrow"
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  aria-label="Next page"
                >
                  &#10095;
                </button>
              </nav>
            )}
          </main>

          {/* =================================================
              RIGHT NAV
          ================================================= */}

          <aside className="real-right-nav">
            <Right_nav setActivePage={setActivePage} />
          </aside>
          {activePage === "home" && (
            <Algo_defination setActivePage={setActivePage} />
          )}
          {activePage === "team_results" && <Right_nav />}
          {activePage === "algorithm_1" && <Right_nav />}
          {activePage === "algorithm_2" && <Right_nav />}
        </div>
      </div>
    </div>
  );
}
